// Google Consent Mode
// https://developers.google.com/tag-platform/devguides/consent

declare global {
    interface Window {
        dataLayer: Array<any>;
    }
}

interface ConsentTypes {
    ad_storage?: "denied" | "granted";
    ad_user_data?: "denied" | "granted";
    ad_personalization?: "denied" | "granted";
    analytics_storage?: "denied" | "granted";
    functionality_storage?: "denied" | "granted";
    personalization_storage?: "denied" | "granted";
    security_storage?: "denied" | "granted";
}

class ConsentMode {
    // None of theses are used because of how global site tag functions
    // It seems to only work when it pushes an argument to dataLayer
    private static addToDatalayer(...args): void {
        // args = command: string, targetId: string, config?: AdvancedConsent | boolean
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(args);
    }

    public static update = (updateTypes: ConsentTypes) => {
        ConsentMode.addToDatalayer("consent", "update", updateTypes);
    };
}

export default ConsentMode;
